import React from 'react'

function LogoWhite() {
    return (
        <img src="/images/lacnic39-logo.svg" alt="LACNIC 39"></img>
    )
}

export default LogoWhite
